"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.signPayload = exports.ownerAddress = void 0;
require("../buffer/buffer");
const providers_1 = require("@ethersproject/providers");
const wallet_1 = require("@ethersproject/wallet");
const rollbar_1 = __importDefault(require("../development/rollbar"));
const segment_1 = __importDefault(require("../development/segment"));
const EmptyAccountsError_1 = __importDefault(require("../errors/EmptyAccountsError"));
const once_1 = __importDefault(require("../function/once"));
const authenticator = (0, once_1.default)(() => Promise.resolve().then(() => __importStar(require('@dcl/crypto/dist/Authenticator'))));
function identify(connection) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            if (!connection.account) {
                throw new EmptyAccountsError_1.default();
            }
            const { Authenticator } = yield authenticator();
            const address = connection.account;
            const provider = connection.provider;
            const wallet = wallet_1.Wallet.createRandom();
            const expiration = 60 * 24 * 30;
            const payload = {
                address: wallet.address,
                privateKey: wallet.privateKey,
                publicKey: wallet.publicKey,
            };
            // provider.
            const identity = yield Authenticator.initializeAuthChain(address, payload, expiration, (message) => new providers_1.Web3Provider(provider).getSigner().signMessage(message));
            return identity;
        }
        catch (err) {
            console.error(err);
            (0, rollbar_1.default)((rollbar) => rollbar.error(err));
            (0, segment_1.default)((analytics) => analytics.track('error', Object.assign(Object.assign({}, err), { message: err.message, stack: err.stack })));
            return null;
        }
    });
}
exports.default = identify;
function ownerAddress(authChain) {
    return __awaiter(this, void 0, void 0, function* () {
        const { Authenticator } = yield authenticator();
        return Authenticator.ownerAddress(authChain).toLowerCase();
    });
}
exports.ownerAddress = ownerAddress;
function signPayload(identity, payload) {
    return __awaiter(this, void 0, void 0, function* () {
        const { Authenticator } = yield authenticator();
        return Authenticator.signPayload(identity, payload);
    });
}
exports.signPayload = signPayload;
